import React, { useState, useRef, useEffect } from "react";
import PageLayout from "../../../../UiKit/Wizard/Page/PageLayout";
import NavigationButton from "../../../../UiKit/Wizard/NavigationButton/NavigationButton";
import SubHeader from "../../../../UiKit/Wizard/SubHeader/SubHeader";
import Body from "../../../../UiKit/Wizard/Body/Body";
import Input from "../../../../UiKit/Wizard/Input/Input";
import ChatbotSelect from "../../../../UiKit/ChatbotSelect/ChatbotSelect";
import PrivacyStatementModal from "../Modal/PrivacyStatementModal";
import useChatbot from "../../../../Hooks/useChatbot";
import "./liveChatCard.css";
import translation from "../translation";
import { useLanguage } from "../../../../UiKit/Wizard/langugeContext";

// Fallbacks for initialization safety
const fallbackCustomerTypeDropdown = [
  { label: "New Consumer", value: "New Consumer" },
  { label: "Existing Consumer", value: "Existing Consumer" },
  { label: "Medi-Cal Consumer", value: "Medi-Cal Consumer" },
];

const fallbackLiveChatTopicDropdown = {
  "New Consumer": [
    { label: "Check Application Status", value: "Check Application Status" },
    { label: "General Information", value: "General Information" },
    { label: "Reset Password", value: "Reset Password" },
    {
      label: "Determine your potential program eligibility",
      value: "Determine your potential program eligibility",
    },
  ],
  "Existing Consumer": [
    { label: "Reset Password", value: "Reset Password" },
    { label: "Report a Change", value: "Report a Change" },
    { label: "Check Application Status", value: "Check Application Status" },
    {
      label: "1095/3895 Tax Document Help",
      value: "1095/3895 Tax Document Help",
    },
    { label: "Renew Coverage", value: "Renew Coverage" },
    { label: "Other Questions", value: "Other Questions" },
  ],
  "Medi-Cal Consumer": [
    { label: "Check Status", value: "Check Status" },
    { label: "Other Questions", value: "Other Questions" },
  ],
}

const LiveChatCard = ({ postActivity, onCancel }) => {
  const { currentLanguage } = useLanguage();
  const { setIsLiveChatActive } = useChatbot();

  const langTranslation = translation[currentLanguage] || {};
  const liveChatTranslations = langTranslation.LiveChatCard || {};
  const liveChatButtonTranslations = langTranslation.button || {};
  const customerTypeDropdown = langTranslation.customerTypeDropdown || fallbackCustomerTypeDropdown;
  const liveChatTopicDropdown = langTranslation.liveChatTopicDropdown || fallbackLiveChatTopicDropdown;
  
  const defaultCustomerType =
  customerTypeDropdown && customerTypeDropdown.length > 0
    ? customerTypeDropdown[0].value
    : "";

const defaultTopicOptions =
  liveChatTopicDropdown && liveChatTopicDropdown[defaultCustomerType]
    ? liveChatTopicDropdown[defaultCustomerType]
    : [];

const defaultLiveChatTopic =
  defaultTopicOptions.length > 0 ? defaultTopicOptions[0].value : "";


  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [customerType, setCustomerType] = useState(defaultCustomerType);
  const [liveChatTopic, setLiveChatTopic] = useState(defaultLiveChatTopic);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const scrollEl =
      document.querySelector(".webchat__scrollable") ||
      document.querySelector(".webchat__basic-transcript__scrollable");
  
    const stackedLayout = scrollEl && scrollEl.firstElementChild;
  
    if (!scrollEl || !stackedLayout) return;
  
    const scrollToBottom = () => {
      requestAnimationFrame(() => {
        scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: "smooth" });
      });
    };
  
    const observer = new MutationObserver(scrollToBottom);
    observer.observe(stackedLayout, { childList: true });
  
    scrollToBottom();
  
    return () => observer.disconnect();
  }, []);
  
  

  const handleCustomerTypeChange = (selectedOption) => {
    const selectedValue = selectedOption.value;
    setCustomerType(selectedValue);
  
    const topics =
      liveChatTopicDropdown &&
      liveChatTopicDropdown[selectedValue] &&
      Array.isArray(liveChatTopicDropdown[selectedValue])
        ? liveChatTopicDropdown[selectedValue]
        : [];
  
    const firstTopic =
      topics.length > 0 && topics[0] && topics[0].value
        ? topics[0].value
        : "";
  
    setLiveChatTopic(firstTopic);
  };
  

  const handleSubmit = () => {
    setIsSubmitting(true);
    postActivity({
      type: "message",
      value: {
        intentName: "liveChatRequest",
        parentIntent: "liveChatRequest",
        title: "liveChatRequest",
        firstName,
        lastName,
        reasonForLiveChat: customerType + " | " + liveChatTopic,
      },
    });
  };

  const handleCancel = () => {
    onCancel();
    document
      .querySelectorAll(".webchat__row.attachment")
      .forEach((row) => (row.style.display = "none"));
  };

  const formOverlayStyle = {
    opacity: isSubmitting ? 0.6 : 1,
    pointerEvents: isSubmitting ? "none" : "auto",
  };

  const shouldPlaceMenuTop = (liveChatTopicDropdown[customerType] || []).length > 3;
  const menuPlacement = shouldPlaceMenuTop ? "top" : "auto";

  const customDropdownStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      maxHeight: "180px",
      overflowY: "auto",
      marginBottom: 0,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      maxHeight: "180px",
    }),
    // menuPortal: (base) => ({
    //   ...base,
    //   zIndex: 9999,
    // }),
  };
  

  return (
    <div className="livechat-card" data-livechat-card style={{ position: "relative" }}>
      <PageLayout>
        <PageLayout.Content>
          <div style={{ padding: "20px", ...formOverlayStyle }}>
            <SubHeader subHeader={liveChatTranslations.header} style={{ marginBottom: "15px" }} />

            <div style={{ display: "flex", marginBottom: "15px" }}>
              <div style={{ flex: 1, marginRight: "10px", minWidth: 0 }}>
                <Body bodyText={liveChatTranslations.firstName} />
                <Input
                  type="text"
                  placeholder={liveChatTranslations.firstName}
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  style={{ width: "100%" }}
                />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <Body bodyText={liveChatTranslations.lastName} />
                <Input
                  type="text"
                  placeholder={liveChatTranslations.lastName}
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  style={{ width: "100%" }}
                />
              </div>
            </div>

            <div style={{ marginTop: "15px" }}>
              <Body bodyText={liveChatTranslations.Customer} />
              <ChatbotSelect
                options={customerTypeDropdown}
                onChange={handleCustomerTypeChange}
                value={customerType}
                placeholder={liveChatTranslations.Customer}
                customStyles={customDropdownStyles}
                // menuPortalTarget={document.body}
              />
            </div>

            <div style={{ marginTop: "15px" }}>
              <Body bodyText={liveChatTranslations.liveChatReason} />
              <ChatbotSelect
                options={liveChatTopicDropdown[customerType]}
                onChange={(e) => setLiveChatTopic(e.value)}
                value={liveChatTopic}
                placeholder={liveChatTranslations.liveChatReason}
                customStyles={customDropdownStyles}
                menuPlacement={menuPlacement}
                // menuPortalTarget={document.body}
              />
            </div>
          </div>
        </PageLayout.Content>

        <PageLayout.Navigation>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 20px 20px",
              ...formOverlayStyle,
            }}
          >
            <NavigationButton
              onClick={handleCancel}
              type="secondary"
              style={{ flex: 1, marginRight: "10px" }}
              disabled={isSubmitting}
            >
              {liveChatButtonTranslations.cancel}
            </NavigationButton>
            <NavigationButton
              onClick={handleSubmit}
              type="primary"
              style={{ flex: 1 }}
              disabled={isSubmitting}
            >
              {liveChatButtonTranslations.sendRequest}
            </NavigationButton>
          </div>
        </PageLayout.Navigation>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <a
            href="#!"
            style={{
              cursor: "pointer",
              color: "#696969",
              textAlign: "center",
              fontSize: "12px",
              paddingBottom: "20px",
            }}
            onClick={() => setIsModalOpen(true)}
          >
            {liveChatTranslations.privacyStatement}
          </a>
        </div>

        {isModalOpen && (
          <PrivacyStatementModal
            type="liveChat"
            insideWizard={true}
            handleClose={() => setIsModalOpen(false)}
          />
        )}
      </PageLayout>
    </div>
  );
};

export default LiveChatCard;
